export const userPointsValues = {
  CORRECT_QUESTION: 10,
  FINISHED_READING: 5,
};
